module.exports = __webpack_public_path__ + "img/Weapon_246.a68600db.png";